module.exports = __webpack_public_path__ + "media/img/illustrations/pencil-5812bf9b69bcd670a268b95f605de6e0.svg";